import request from '@/utils/request';
//优惠券列表
export function getUserGroupList(values) {
  return request('/profile/queryGroupPage', {
    method: 'POST',
    data: values,
  });
}

//优惠券详情
export function getQueryGroupInfo(values) {
  return request('/profile/group/queryGroupInfo', {
    method: 'POST',
    data: values,
  });
}
//获取活动相关信息
export function getActivityInfo(values) {
  return request('/activityGroup/queryOne', {
    method: 'POST',
    data: values,
  });
}
//新增活动人群
export function addActivityGroup(values) {
  return request('/activityGroup/add', {
    method: 'POST',
    data: values,
  });
}
//更新活动人群
export function updateActivityGroup(values) {
  return request('/activityGroup/update', {
    method: 'POST',
    data: values,
  });
}

// 获取微信模板信息
export function getWechatTemplateList(values) {
  return request('/message/queryWechatTemplateList', {
    method: 'POST',
    data: values,
  });
}
// 获取短信模板消息
export function getSmsTemplateList() {
  return request('/sms/queryTemplateList', {
    method: 'GET',
    // params: values,
  });
}
// 获取周期类型列表
export function getCycleTypeList() {
  return request('/activityGroup/cycleTypeList', {
    method: 'GET',
    // params: values,
  });
}
// 获取每月天数列表
export function getMonthDayList() {
  return request('/activityGroup/monthDayList', {
    method: 'GET',
    // params: values,
  });
}
// 获取每周天数
export function getWeekDayList() {
  return request('/activityGroup/weekDayList', {
    method: 'GET',
    // params: values,
  });
}
